module.exports = __webpack_public_path__ + "03268c01dfbc2d7e090b86084f066272.png";